import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Collapse from '@mui/material/Collapse';

import { PasswordInput, MixPanelTrackedLink } from ".";
import useForm from "../hooks/UseForm";
import { validatePassewordChange } from "../validations";
import { displayError } from "../helpers";
import { profileActions } from "../store/actions";
// import { response } from "express";

export function UpdatePassword() {
    let auth = useSelector(state => state.authentication);
    const errors = useSelector(state => state.validationErrors);

    let dispatch = useDispatch();
    const [state, setState] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    })

    const [loading, setLoading] = useState(false);
    const [displayPasswordForm, setDisplayPasswordForm] = useState(false);
    const [buttonText, setButtonText] = useState("Change Password");

    const handleChangePasswordClick = () => {
        if (displayPasswordForm) {
            handleSubmit();
        }
        else setDisplayPasswordForm(true)
    }

    const updateState = (e) => {
        const { name, value } = e.target;
        setState({
            ...state,
            [name]: value
        })
    }

    const updatePassword = async () => {
        setLoading(true);
        const { currentPassword, newPassword, confirmPassword } = state;
        const payload = {
            password: newPassword,
            password_confirmation: confirmPassword,
            password_current: currentPassword,
            email: auth.user.email
        };
        await dispatch(profileActions.changePassword(payload));
        setLoading(false)
        setState({
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
        });
        setDisplayPasswordForm(false);
    }
    const { handleChange, handleSubmit } = useForm(updatePassword, validatePassewordChange, updateState, state);

    useEffect(() => {
        displayPasswordForm ? setButtonText("Save Password") : setButtonText("Change Password")
    }, [displayPasswordForm])
    return <React.Fragment>
        <Grid container alignItems="center" spacing={2}>
            <Grid item xs={7}>
                <Typography
                    sx={{
                        fontWeight: 800,
                        fontSize: '17px',
                        color: 'black'
                    }}>
                    Change Password
                </Typography>
            </Grid>
            <Grid item xs={5} textAlign="end">
                <MixPanelTrackedLink
                    type="button"
                    label={buttonText}
                    context="Updating password"
                    size="small"
                    variant="outlined"
                    onClick={handleChangePasswordClick}
                >
                    {loading ? <CircularProgress size={20} /> : buttonText}
                </MixPanelTrackedLink>
                {/* <Button size="small" variant="outlined" onClick={handleChangePasswordClick}>{loading ? <CircularProgress size={20} /> : buttonText}</Button> */}
            </Grid>

            <Grid item xs={12}>
                <Collapse in={displayPasswordForm}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <PasswordInput
                                name="currentPassword"
                                label="Current Password"
                                value={state.currentPassword}
                                onChange={handleChange}
                                error={displayError(errors?.currentPassword)}
                                helperText={errors?.currentPassword}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <PasswordInput
                                name="newPassword"
                                label="New Password"
                                value={state.newPassword}
                                onChange={handleChange}
                                error={displayError(errors?.newPassword)}
                                helperText={errors?.newPassword}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <PasswordInput
                                name="confirmPassword"
                                label="Confirm Password"
                                value={state.confirmPassword}
                                onChange={handleChange}
                                error={displayError(errors?.confirmPassword)}
                                helperText={errors?.confirmPassword}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Collapse>
            </Grid>
        </Grid>
    </React.Fragment>
}